import { render } from "./YearsBeforeChart.vue?vue&type=template&id=9669fb1e"
import script from "./YearsBeforeChart.vue?vue&type=script&lang=js"
export * from "./YearsBeforeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__